export const feedOperations = {
  1: {
    "type": "0",
    "name": "Sort",
    "relativePath": "",
    "groupPath": "",
    "subType": "0",
    "subTypeData": ""
  },
  2: {
    "type": "2",
    "name": "Priority",
    "caseSensitive": false,
    "relativePath": "",
    "groupPath": "",
    "subType": "0",
    "matches": [],
  },
  3: {
    "type": "3",
    "name": "Filter",
    "caseSensitive": false,
    "groupType": "",
    "relativePath": "",
    "subType": "0",
    "matches": [],
  },
  4: {
    "type": "5",
    "name": "Replace Text",
    "relativePath": "",
    "groupPath": "",
    "caseSensitive": false,
    "matches": []
  }
};

export const sortOrderOption = [
  {
    name: "Ascending Order",
    value: "0"
  },
  {
    name: "Descending Order",
    value: "1"
  }
];

export const sortTypeOption = [
  {
    name: "Text",
    value: "0",
  },
  {
    name: "Number",
    value: "1"
  },
  {
    name: "Date",
    value: "2"
  }
];

export const expressionOption = [
  {
    name: "Contains",
    value: "0"
  },
  {
    name: "Starts with",
    value: "1"
  },
  {
    name: "Ends with",
    value: "2"
  },
  {
    name: "Equals",
    value: "3"
  },
  {
    name: "Is lesser than or equals",
    value: "4"
  },
  {
    name: "Is lesser than",
    value: "5"
  },
  {
    name: "Is greater than or equals",
    value: "6"
  },
  {
    name: "Is greater than",
    value: "7"
  }
];

export const includeExclude = [
  {
    name: "Include",
    value: "3"
  },
  {
    name: "Exclude",
    value: "4"
  }
];

export const intervalOption = [
  {
    name: "Every 15 seconds",
    value: 15 * 1000
  },
  {
    name: "Every minute",
    value: 60 * 1000
  },
  {
    name: "Every 5 minutes",
    value: 300 * 1000
  },
  {
    name: "Every 10 minutes",
    value: 600 * 1000
  },
  {
    name: "Every 20 minutes",
    value: 1200 * 1000
  },
  {
    name: "Every 30 minutes",
    value: 1800 * 1000
  },
  {
    name: "Every hour",
    value: 3600 * 1000
  },
  {
    name: "Every 3 hours",
    value: 10800 * 1000
  },
  {
    name: "Every 6 hours",
    value: 21600 * 1000
  },
  {
    name: "Every 12 hours",
    value: 43200 * 1000
  },
  {
    name: "Every day",
    value: 86400 * 1000
  },
  {
    name: "Every week",
    value: 604800 * 1000
  }
];